try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-Frampton'] = Date.now();

import * as Vue from 'vue';
import { store } from '../data_hub';
// require('Modernizr');

import loaderOverlay from '../mixins/loaderOverlay';
import postToUrl from '../mixins/postToUrl';

const app = Vue.createApp({
    data(){
        return {
            order_data: null,
            shipping_instructions: null,
            recalculating_coins: false,
            recalculation_buffer: null,
            step: null
        }
    },
    created(){
        this.$store.commit('setScreenMode');
        let timer;
        window.addEventListener("resize",()=>{
            if(timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.$store.commit('setScreenMode');
            },50);
        });
    },
    mounted(){
        this.hideLoader();

        this.step = $('.checkout').data('step');

        switch(this.step) {
            case 'basket': // initial call to get cart data - if on step 1 (basket) page!
                this.showLoader('Processing basket');

                axios.get(`/community/store/api/basket`).then((response)=>{

                    this.order_data = response.data;
                    this.shipping_instructions = this.order_data.customer_info?.shipping_instructions === undefined ? null : this.order_data.customer_info.shipping_instructions;
                    this.hideLoader();

                }).catch((e) => { this.axiosError(e) });
                break
            case 'details': // billing & shipping details
                const usebf = $('input[name="use_billing_address"]:checked').val();
                this.toggleShippingFields(usebf);

                $('input[name="use_billing_address"]').change((e)=>{
                    this.toggleShippingFields(e.target.value);
                });
                break;
            case 'payment':

                // ...

                break;
        }
    },
    methods: {
        toggleShippingFields(usebf)
        {
            usebf = parseInt(usebf);
            const sft = $('#shipping-fields-toggle');
            usebf ? sft.hide() : sft.show();
        },
        updateRowQuantity(row)
        {
            this.showLoader('Updating basket');

            axios.put(`/community/store/api/basket/${row.rowId}/${row.qty}`).then((response)=>{

                this.order_data = response.data;
                this.hideLoader();

            }).catch((e) => { this.axiosError(e) });
        },
        deleteRow(rowId)
        {
            new Promise((resolve, reject)=>{

                const msg = (this.order_data.basket.rows.length === 1)
                            ? 'This is the last item in your basket. Deleting it will cancel this order completely. Continue?'
                            : 'Are you sure you want to delete this item?';

                    if(confirm(msg)){
                        resolve();
                    }else{
                        reject();
                    }

            }).then(()=>{
                this.showLoader('Updating basket');

                axios.delete(`/community/store/api/basket/${rowId}`).then((response)=>{

                    if(response.data.basket.rows.length === 0){
                        window.location.reload();
                    }else{
                        this.order_data = response.data;
                        this.hideLoader();
                    }

                }).catch((e) => { this.axiosError(e) });
            }).catch(()=>{
                // rejected
            })
        },
        updateShippingCountry(country_code)
        {
            this.showLoader('Updating basket');

            axios.patch(`/community/store/api/shipping-country/${country_code}`).then((response)=>{

                this.order_data = response.data;
                this.hideLoader();

            }).catch((e) => { this.axiosError(e) });
        },
        assignedStretchCoins(amount)
        {
            this.recalculating_coins = true;
            clearTimeout(this.recalculation_buffer);

            this.recalculation_buffer = setTimeout(()=>{
                axios.post(`/community/store/api/assign-coins/${amount}`).then((response)=>{

                    this.order_data = response.data;
                    this.recalculating_coins = false;

                }).catch((e) => { this.axiosError(e) });
            },350);
        },
        doCoinPayment() // for coin-only purchases. Otherwise call is made in StoreCheckoutPaymentComponent
        {
            this.showLoader('Processing');

            setTimeout(()=>{
                this.postToUrl('/community/store/checkout/payment', {
                    coins_only: true,
                });
            },300);

            // axios.post('/community/store/api/payment', { coins_only: true }).then((response)=>{
            //
            //     setTimeout(()=>{
            //         window.location.href = '/community/store/checkout/complete';
            //     },1000);
            //
            // }).catch((e) => {
            //     if(e.response){
            //         this.hideLoader();
            //         alert('Sorry, an error occurred processing this transaction.');
            //     }else {
            //         throw new Error('An error occurred with the Stripe API. Code: A0B');
            //     }
            // });
        },
        axiosError(e){
            if(e.response){
                console.error('Axios error');
                console.log(e.response.data);
                console.log(e.response.status);
            }else {
                throw new Error('An error occurred connecting with the server.');
            }
            // location.reload(); // session may have expired
        }
    }
});

app.mixin(postToUrl);
app.mixin(loaderOverlay);
app.use(store);

app.component('nav-component', require('../components/NavComponent').default);
app.component('product-gallery-viewer', require('./components/ProductGalleryViewer').default);
app.component('checkout-basket', require('./components/CheckoutBasket').default);
app.component('shipping-country-selector', require('./components/ShippingCountrySelector').default);
app.component('stretchcoin-selector', require('./components/StretchcoinSelector').default);
app.component('store-checkout-payment-component', require('./components/StoreCheckoutPaymentComponent').default);

app.config.globalProperties.$filters = {
    getCurrencyValue(value)
    {
        if (typeof value !== "number") {
            return value;
        }
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 2
        });
        return formatter.format(value);
    },
};

app.mount('#app');
